export class LabosApiError extends Error {
    constructor(options) {
        super(options.message);
        this.name = 'LabosApiError';
        this.status = options.status;
        this.service = options.service;
        this.message = options.message;
        Object.setPrototypeOf(this, LabosApiError.prototype);
    }
}
